import { MediaResponse } from '@api/backend';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { ErrorResponse } from '@core/models';
import { inject } from '@angular/core';
import { PornRepository } from '@core/repositories/porn.repository';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { debounceTime, distinctUntilChanged, pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { ClipboardService } from '@shared/services/clipboard.service';
import { filter } from 'rxjs/operators';
import { sessionSelectors } from '@store/session';
import { Store } from '@ngrx/store';

type FeedState = {
  feed: MediaResponse[] | null;
  isLoading: boolean;
  error: ErrorResponse | null;
  totalPages: number;
};

const initialFeedState: FeedState = {
  feed: null,
  isLoading: false,
  error: null,
  totalPages: 0,
};


export const VideosStore = signalStore(
  withState(initialFeedState),
  withMethods((
    state,
    api = inject(PornRepository),
    globalStore = inject(Store),
    clipboardService = inject(ClipboardService),
  ) => ({
    loadByQuery: rxMethod<{ t?: string, c?: string, r?: string, a?: string, q?: string, p?: number }>(
      pipe(
        debounceTime(10),
        distinctUntilChanged(),
        tap(() => patchState(state, { isLoading: true })),
        switchMap((params) => {
          return api.getList(params).pipe(
            tapResponse({
              next: (feed) => patchState(state, { feed: feed.data.media, totalPages: feed.data.total_pages }),
              error: () => {},
              finalize: () => patchState(state, { isLoading: false }),
            }),
          );
        }),
      ),
    ),
    like: rxMethod<{ mediaId: string }>(
      pipe(
        debounceTime(10),
        filter(() => globalStore.selectSignal(sessionSelectors.selectIsSetUser)()),
        distinctUntilChanged(),
        switchMap(({ mediaId }) => api.like(mediaId)),
      ),
    ),
    unlike: rxMethod<{ mediaId: string }>(
      pipe(
        debounceTime(10),
        filter(() => globalStore.selectSignal(sessionSelectors.selectIsSetUser)()),
        distinctUntilChanged(),
        switchMap(({ mediaId }) => api.unlike(mediaId)),
      ),
    ),
    share: rxMethod<{ mediaId: string }>(
      pipe(
        debounceTime(10),
        filter(() => globalStore.selectSignal(sessionSelectors.selectIsSetUser)()),
        distinctUntilChanged(),
        tap(({ mediaId }) => {
          clipboardService.copy(`video/${mediaId}`);
        }),
        switchMap(({ mediaId }) => api.share(mediaId)),
      ),
    ),
  })),
);